export enum SettingsPortalTestIds {
  Portal = `flock-settings-portal`,
}
